import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
//import { FieldType, BaseFormlyFieldProps } from '../form-field/public_api';
import { BaseFormlyFieldProps } from '../form-field/public_api';

interface SelectProps extends BaseFormlyFieldProps, FormlyFieldSelectProps {
    primitive?: boolean;
    defaultItem?: any;
    filterable?: boolean;
}

export interface FormlySelectFieldConfig extends FormlyFieldConfig<SelectProps> {
    type: 'kendo-select' | Type<FormlyFieldSelect>;
}

@Component({
    selector: 'formly-field-kendo-select',
    template: `
    <kendo-dropdownlist
      [formControl]="formControl"
      [formlyAttributes]="field"
      [filterable]="props.filterable"
      [kendoDropDownFilter]="filterSettings"
      [defaultItem]="props.defaultItem"
      [data]="props.options | formlySelectOptions: field | async"
      [textField]="textField"
      [valueField]="valueField"
      [valuePrimitive]="props.primitive ?? true"
      [readonly]="props.readonly === true"
      (valueChange)="props.change && props.change(field, $event)"
    >
    </kendo-dropdownlist>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldSelect extends FieldType<FieldTypeConfig<SelectProps>> {
    get textField() {
        const label = this.props.labelProp as string;
        return label ?? 'label';
    }
    get valueField() {
        const value = this.props.valueProp as string;
        return value ?? 'value';
    }
    filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: "contains",
    };
}
